import React from 'react';
import Box from '@mui/material/Box';
import { sp } from '@/theme/mui';

import { Button } from '@/components/atoms/Button/Button';
import { RowAction } from '@/components/organisms/Table/Table';

export interface SimpleTableRow {
  label: string;
  value: string;
}

export interface SimpleTableProps {
  rows: SimpleTableRow[];
  actions?: RowAction[];
}

export const SimpleTable = ({ rows, actions }: SimpleTableProps) => {
  return (
    <>
      <Box sx={{ width: '100%', overflowY: 'auto', maxHeight: '600px' }}>
        <Box
          component='table'
          sx={{
            width: '100%',
            borderCollapse: 'collapse',
            mt: sp[16],
            tableLayout: 'fixed',
            '& th': {
              textAlign: 'left',
              p: sp[12],
              typography: 'bodyMediumWeight',
              color: '#404042',
              borderBottom: '1px solid #f2ede3',
              width: '50%',
            },
          }}
        >
          <tbody>
            {rows.map((row: SimpleTableRow, index: number) => (
              <tr key={index}>
                <Box
                  component='td'
                  sx={{
                    p: sp[12],
                    typography: 'bodyMediumWeight',
                    color: '#404042',
                    borderBottom: '1px solid #f2ede3',
                    verticalAlign: 'middle',
                    width: '50%',
                    wordBreak: 'break-word',
                    fontWeight: 'bold',
                  }}
                >
                  {row.label}
                </Box>
                <Box
                  component='td'
                  sx={{
                    p: sp[12],
                    typography: 'bodyMd',
                    color: '#8c8c8d',
                    borderBottom: '1px solid #f2ede3',
                    verticalAlign: 'middle',
                    whiteSpace: 'pre-wrap',
                    width: '50%',
                    wordBreak: 'break-word',
                  }}
                >
                  {row.value}
                </Box>
              </tr>
            ))}
          </tbody>
        </Box>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: sp[16] }}>
        {actions?.map((action, index) => (
          <Button
            key={index}
            ariaLabel={action.label}
            variant={action.buttonVariant || 'primary'}
            onPress={() => action.onPress(rows)}
            iconLeft={action.iconLeft}
            size={action.buttonSize || 'md'}
            isDisabled={action.isDisabled}
          >
            {action.label}
          </Button>
        ))}
      </Box>
    </>
  );
};

SimpleTable.displayName = 'SimpleTable';

export default SimpleTable;
